import { useApiClient } from '../composables/useApiClient.ts';

export interface BankAccount {
    label?: string,
    account_number?: string,
    swift?: string,
    iban_code?: string,
    person?: number,
    owner?: number,
}

export default {
    getBoss() {
        return useApiClient().post('/persons/get-boss');
    },
    getBankAccountByPerson(id: number) {
        return useApiClient().get(`/persons/bank_accounts/bankaccountbyperson/${id}`);
    },
    addBankAccount(payload: BankAccount) {
        return useApiClient().post('/persons/bank_accounts', { bankaccount: { ...payload } });
    },
    checkIfCompanyExists(nip: string) {
        return useApiClient().post('/persons/companies/check-by-nip', { nip });
    },
    addAddress(payload) {
        return useApiClient().post('/persons/addresses', { address: { ...payload } });
    },
    getAddress(id: number) {
        return useApiClient().get(`/persons/addresses/${id}`);
    },
    updateAddress(id: number, payload) {
        return useApiClient().put(`/persons/addresses/${id}`, { address: { id, ...payload } });
    },
    deleteAddress(id: number) {
        return useApiClient().delete(`/persons/addresses/${id}`);
    },
    getAddressesByPerson(personId: number) {
        return useApiClient().get(`/persons/addressesbyperson/${personId}`, { params: { list: true } });
    },
    searchPostalCode(code: string) {
        return useApiClient().get('/address/postal-code/search', { params: { postal_code: code } });
    },
    getCompanyTypes() {
        return useApiClient().get('/persons/company-type');
    },
    getTaxOffices() {
        return useApiClient().get('/persons/tax-offices');
    },
    getCountries() {
        return useApiClient().get('/persons/country-type/dictionary');
    },
};
